import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import DNSearchBar, { DNSearchBarProps } from '@/design-components/organisms/dnsearch-bar';
import { historyBack } from '@/utils/mobile/RNPlugins';

interface DNSearchHeaderProps extends DNSearchBarProps {
  onClickBackButton?: () => void;
}

const DNSearchHeader = ({ onClickBackButton = historyBack, ...props }: DNSearchHeaderProps) => {
  return (
    <SearchBarWrapper id={'appHeader'}>
      <IconWrapper onClick={onClickBackButton}>
        <MaterialIcon name={'arrow_back_ios_new'} />
      </IconWrapper>
      <DNSearchBar {...props} />
    </SearchBarWrapper>
  );
};

export default DNSearchHeader;

const SearchBarWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding-right: 24px;
  padding-bottom: 6px;
  
  ${({ theme }) => `
    padding-top: ${theme.client.isWebView && theme.client.isAndroid ? '12px' : '6px'};
    height: ${theme.client.isWebView && theme.client.isAndroid ? '66px' : theme.size.appHeader.height};
    background: ${theme.color.white};
  `};
`;

const IconWrapper = styled.button`
  margin: 0 16px;
  padding: 2px;
  border-radius: 8px;

  ${({ theme }) => `
    &: hover {
      background: ${theme.color.gray30};
    };
    &: active {
      background: ${theme.color.gray50};
    }
  `};
`;
